<app-tdi-intro></app-tdi-intro>
<app-tdi-quote></app-tdi-quote>
<app-tdi-optimize></app-tdi-optimize>
<app-tdi-struggles></app-tdi-struggles>
<app-tdi-how-works></app-tdi-how-works>
<app-tdi-benefits></app-tdi-benefits>
